import { __decorate } from "tslib";
// NPM
import { Component, Mixins } from "vue-property-decorator";
// SYSTEM1
import Loader from "@/components/widgets/loader.vue";
import Layout from "@/router/layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import simplebar from "simplebar-vue";
import Switches from "vue-switches";
import BaseMixer from "@/router/views/BaseMixer";
import { AssetMasterModule } from "@/store/modules/asset.module";
import { Guid } from "guid-typescript";
import AssetTypePropertyComponent from "../asset/components/AssetTypePropertyComponent.vue";
import SectionLoader from "@/components/widgets/SectionLoader.vue";
import { toaster } from "@/utilities/toaster";
import { AssetCullOutReportRequestModel } from "@/store/models/asset/assetCullOtReportRequestDTO";
Component.registerHooks(["metaInfo"]);
let AssetCullOutReport = /** @class */ (() => {
    let AssetCullOutReport = class AssetCullOutReport extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.title = "Asset Cull Out Report";
            this.pageIsLoading = false;
            this.isPageLoading = false;
            this.isTableLoading = false;
            this.showTable = false;
            this.showProperties = false;
            this.showAssetType = false;
            this.showTeam = false;
            this.showMandatory = true;
            this.cullOutRequest = new AssetCullOutReportRequestModel();
            this.assetCategoryId = Guid.createEmpty();
            this.teamId = Guid.createEmpty();
            this.assetTypeId = Guid.createEmpty();
            this.emptyGuid = Guid.createEmpty();
            this.selectYear = "";
            this.selectedTeam = "";
            this.selectedCategory = "";
            this.selectedAssetType = "";
            this.isTeam = false;
            this.isCategory = false;
            this.isAssetType = false;
            this.filterTeam = "";
            this.filterCategory = "";
            this.filterAssetType = "";
            this.selectedYear = "";
            this.items = [
                {
                    text: "Home",
                    to: "/dashBoard",
                },
                {
                    text: "Reports",
                },
                {
                    text: "Asset Cull Out Report",
                    active: true,
                },
            ];
        }
        get yearList() {
            return AssetMasterModule.yearList;
        }
        get teamList() {
            return AssetMasterModule.teamList;
        }
        get assetCategories() {
            return AssetMasterModule.assetCategories;
        }
        get cullOutReportAssetTypes() {
            return AssetMasterModule.cullOutReportAssetTypes;
        }
        get assetProperties() {
            return AssetMasterModule.getAssetProperties;
        }
        get assetControlTypes() {
            return AssetMasterModule.getAssetControlType;
        }
        get cullOutAssets() {
            return AssetMasterModule.cullOutAssets;
        }
        getAssetTypesByCategoryId() {
            this.showProperties = false;
            AssetMasterModule.clearGetAssetProperties();
            this.assetTypeId = this.emptyGuid;
            AssetMasterModule.GetAssetTypeByAssetCategoryId(this.assetCategoryId).then((res) => {
                if (res) {
                    this.showAssetType = true;
                }
            });
        }
        getAssetTypePropertiesByAssetType() {
            AssetMasterModule.GetAssetTypePropertiesByAssetTypeId(this.assetTypeId).then((res) => {
                if (res) {
                    this.showProperties = true;
                }
            });
        }
        CollapseTeam() {
            this.teamId = this.emptyGuid;
            if (this.showTeam == true) {
                this.cullOutRequest.isTeam = true;
            }
            else {
                this.cullOutRequest.isTeam = false;
            }
        }
        getCullOutAssets() {
            this.isTableLoading = true;
            var selectedTeam = this.teamList.find((team) => team.id === this.teamId);
            if (selectedTeam !== undefined) {
                this.selectedTeam = selectedTeam.value;
                this.isTeam = true;
            }
            if (this.teamId === this.emptyGuid && this.showTeam == false) {
                this.selectedTeam = "";
                this.isTeam = false;
            }
            if (this.teamId === this.emptyGuid && this.showTeam == true) {
                this.selectedTeam = "All";
                this.isTeam = true;
            }
            var selectedAssetCategory = this.assetCategories.find((category) => category.id === this.assetCategoryId);
            if (selectedAssetCategory !== undefined) {
                this.selectedCategory = selectedAssetCategory.value;
                this.isCategory = true;
            }
            if (this.assetCategoryId === this.emptyGuid) {
                this.selectedCategory = "";
                this.isCategory = false;
            }
            var selectedAssetType = this.cullOutReportAssetTypes.find((assetType) => assetType.id === this.assetTypeId);
            if (selectedAssetType !== undefined) {
                this.selectedAssetType = selectedAssetType.value;
                this.isAssetType = true;
            }
            if (this.assetTypeId === this.emptyGuid) {
                this.selectedAssetType = "";
                this.isAssetType = false;
            }
            this.selectedYear = this.selectYear;
            this.cullOutRequest.assetTypeProperty = [];
            this.cullOutRequest.year = Number(this.selectYear);
            this.cullOutRequest.assetCategoryId = this.assetCategoryId.toString();
            this.cullOutRequest.assetTypeId = this.assetTypeId.toString();
            this.cullOutRequest.teamId = this.teamId.toString();
            for (var assetProp in this.assetProperties) {
                if (this.assetProperties[assetProp].assetTypePropertyValue != null) {
                    this.cullOutRequest.assetTypeProperty.push({
                        id: Guid.EMPTY,
                        assetTypePropertyId: this.assetProperties[assetProp].id,
                        assetTypePropertyValue: this.assetProperties[assetProp].assetTypePropertyValue,
                    });
                }
            }
            if (this.cullOutRequest.assetCategoryId == this.emptyGuid.toString() &&
                this.cullOutRequest.assetTypeId == this.emptyGuid.toString() &&
                this.cullOutRequest.year == 0 &&
                this.cullOutRequest.teamId == this.emptyGuid.toString() &&
                this.isTeam == false) {
                this.showTable = false;
                toaster.ShowError("Please choose any one of the criteria in the filter");
                this.isTableLoading = false;
            }
            else {
                AssetMasterModule.AssetCullOutReport(this.cullOutRequest).then((res) => {
                    if (res) {
                        this.showTable = true;
                    }
                    this.isTableLoading = false;
                });
            }
        }
        getCullOutReportAsExcel() {
            this.isPageLoading = true;
            this.cullOutRequest.year = Number(this.selectYear);
            this.cullOutRequest.assetCategoryId = this.assetCategoryId.toString();
            this.cullOutRequest.assetTypeId = this.assetTypeId.toString();
            this.cullOutRequest.teamId = this.teamId.toString();
            for (var assetProp in this.assetProperties) {
                if (this.assetProperties[assetProp].assetTypePropertyValue != null) {
                    this.cullOutRequest.assetTypeProperty.push({
                        id: Guid.EMPTY,
                        assetTypePropertyId: this.assetProperties[assetProp].id,
                        assetTypePropertyValue: this.assetProperties[assetProp].assetTypePropertyValue,
                    });
                }
            }
            AssetMasterModule.AssetCullOutReportAsExcel(this.cullOutRequest).then((res) => {
                if (res) {
                    const blob = new Blob([res], {
                        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                    });
                    const link = document.createElement("a");
                    link.href = window.URL.createObjectURL(blob);
                    document.body.appendChild(link);
                    link.download = `AssetCullOutReport.xlsx`;
                    link.click();
                    this.isPageLoading = false;
                }
            });
        }
        clearFilter() {
            this.cullOutRequest.isTeam = false;
            this.selectedYear = "";
            this.selectYear = "";
            this.showTeam = false;
            this.selectedTeam = "";
            this.selectedCategory = "";
            this.selectedAssetType = "";
            this.assetCategoryId = Guid.createEmpty();
            this.assetTypeId = Guid.createEmpty();
            this.teamId = Guid.createEmpty();
            AssetMasterModule.clearGetAssetProperties();
            AssetMasterModule.clearGetAssetTypes();
            AssetMasterModule.ClearYearlyAssetsReport();
            this.showTable = false;
            this.showAssetType = false;
            this.isTeam = false;
            this.showProperties = false;
        }
        created() {
            this.pageIsLoading = true;
            AssetMasterModule.AssetCullOutReportDefaults().then((res) => {
                if (res) {
                    this.pageIsLoading = false;
                    this.clearFilter();
                }
            });
        }
    };
    AssetCullOutReport = __decorate([
        Component({
            name: "AssetCullOut",
            components: {
                Loader,
                Layout,
                PageHeader,
                Switches,
                simplebar,
                SectionLoader,
                AssetTypePropertyComponent,
            },
        })
    ], AssetCullOutReport);
    return AssetCullOutReport;
})();
export default AssetCullOutReport;
